import Common from "../../../../Common";

export interface TtsPlayBody {
	tts: string
	tts_voice: string
	tts_rate?: string | number | null
	tts_pitch?: string | number | null
	tts_supplier?: TTSSupplier
}

const Tts = class extends Common {
	browse = (companyId: id, soundId: id) =>
		this.get(`/company/${companyId}/pbx/soundfile/${soundId}/tts`);

	read = (companyId: id, soundId: id, id: id) =>
		this.get(`/company/${companyId}/pbx/soundfile/${soundId}/tts/${id}`);

	language = (companyId: id): CustomResponse<TTSLanguage[]> =>
		this.get(`/company/${companyId}/pbx/soundfile/tts/language`);
}

export default Tts
